import axios from "axios";
import { logout } from "@/actions/auth";
import router from "@/router";

const api = axios.create({
  baseURL: process.env.VUE_APP_URL_BACKEND,
});

export const getHeaders = (withToken = true) => {
  const bearer = `Bearer ${localStorage.getItem("pop_home_token")}`;
  return {
    headers: {
      "Content-Type": "application/json",
      ...(withToken ? { authorization: bearer } : {}),
    },
  };
};

api.interceptors.request.use((config) => {
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      logout();
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

export default api;
